import { Reducer } from 'redux';
import {
    DATA_EXPORTS_ERROR,
    DATA_EXPORTS_RESET,
    DATA_EXPORTS_FETCH_START,
    DATA_EXPORTS_FETCH_SUCCESS,
    DATA_EXPORTS_CREATE_START,
    DATA_EXPORTS_CREATE_SUCCESS,
    DataExportsAction
} from 'actions/dataExports/DataExportsActionsTypes';
import { DataExportsState, DataExportsStatus } from './DataExportsState';

const initialState: DataExportsState = {
    dataExports: [],
    status: DataExportsStatus.Initial,
    loading: false,
    creating: false
};

export const dataExportsReducer: Reducer<DataExportsState, DataExportsAction> = (state = initialState, action) => {
    switch (action.type) {
        case DATA_EXPORTS_RESET:
            return {
                ...initialState
            };

        case DATA_EXPORTS_ERROR:
            return {
                ...state,
                loading: false,
                creating: false,
                status: DataExportsStatus.Error,
                error: action.payload.error
            };

        case DATA_EXPORTS_FETCH_START:
            return {
                ...state,
                loading: true,
                status: DataExportsStatus.Fetching,
                error: undefined
            };

        case DATA_EXPORTS_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                status: DataExportsStatus.FetchSuccess,
                error: undefined,
                dataExports: action.payload.dataExports
            };

        case DATA_EXPORTS_CREATE_START:
            return {
                ...state,
                creating: true,
                status: DataExportsStatus.Creating,
                error: undefined
            };

        // New exports go on top: the list is ordered newest first.
        case DATA_EXPORTS_CREATE_SUCCESS:
            return {
                ...state,
                creating: false,
                status: DataExportsStatus.CreateSuccess,
                dataExports: [action.payload.dataExport, ...state.dataExports]
            };

        default:
            return state;
    }
};
